module.exports = __webpack_public_path__ + "img/uk-dining-2.139a9880.png";